import React from 'react';
import { connect } from 'react-redux';
import { movil } from '../app-movil';

const mapState = (state) => {
    return {};
}

const mapDispatch = (dispatch) => {
    return {
        resetSiguientePreguntas: () => {
            dispatch({ "type": "MI_PERFIL_RESET_SIGUIENTE_PREGUNTAS" });
        },
        resetPaso: () => {
            dispatch({ "type": "LOGIN_RESET_PASO" });
        }
    }
}

class PasoTresPreguntas extends React.Component {
    state = {

    }

    okPreguntas = () => {
        let mensaje = { "return": "miPerfil", "proceso": "cambioPreguntas" };
        movil("cambioPreguntas", mensaje);
        this.props.resetSiguientePreguntas();
        this.setState({ inputClassPreguntaUno: "input-wrap ver-input" });
        this.setState({ inputClassPreguntaDos: "input-wrap ver-input" });
        this.setState({ inputClassContrasenaPreguntasEdit: "input-wrap ver-input" });
        this.setState({ inputActivePreguntaUnoEdit: "" });
        this.setState({ inputActivePreguntaDosEdit: "" });
        this.setState({ inputActiveContrasenaPreguntasEdit: "" });
        this.setState({ inputPreguntaUnoType: "password" });
        this.setState({ inputPreguntaDosType: "password" });
        this.setState({ inputContrasenaPreguntasEditType: "password" });
        this.setState({ respuestaUnoEdit: "" });
        this.setState({ RespuestaDosEdit: "" });
        this.setState({ contrasenaPreguntasEdit: "" });
        $('#modal-editar-preguntas').modal('toggle');
    }

    goToLogin = () => {
        //$("#modal-user-bloqueado").modal("toggle");
        $('#modal-editar-preguntas').modal('toggle');
        this.props.resetPaso();
    }

    render() {
        const isMoral = JSON.parse(localStorage.getItem("esMoral"));
        console.log("Es moral: ", isMoral, "tipo", typeof isMoral);
        return <div>
            {localStorage.getItem("clienteUnico") === null &&
                <div>
                    <h5>
                        <i>
                            <img src={require("../img/icon-question.png")} />
                        </i>Preguntas secretas actualizadas
                    </h5>
                    <hr className="mt-34" />
                    <div className="texto-17">
                        <p>{isMoral == 2 ? "Tu información se ha guardado satisfactoriamente, de ahora en adelante puedes utilizar tus nuevas preguntas secretas tanto en portal, app Soy Cliente GNP y en el portal Soy Cliente Empresarial | Sector Público." : "Tu información se ha guardado satisfactoriamente, de ahora en adelante puedes utilizar tus nuevas preguntas secretas tanto en portal como en app Soy Cliente GNP."}</p>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="text-center aceptar-cancelar-btn mt-50">
                                <a className="orange-btn" onClick={this.okPreguntas}>Aceptar</a>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {localStorage.getItem("clienteUnico") !== null &&
                <div>
                    <h5>
                        <i>
                            <img src={require("../img/icon-question.png")} />
                        </i>Cuenta desbloqueada
                    </h5>
                    <hr className="mt-34" />
                    <div className="texto-17">
                        <p>¡Listo! Tu cuenta ha sido desbloqueada, ingresa nuevamente para acceder a tu cuenta.</p>
                        <p></p>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="text-center aceptar-cancelar-btn mt-50">
                                <a className="orange-btn" onClick={this.goToLogin}>Aceptar</a>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    }
}

export default connect(mapState, mapDispatch)(PasoTresPreguntas);


// WEBPACK FOOTER //
// ./src/miPerfil/pasoTresPreguntas.cmpt.js